import React, { useState } from 'react';
import { Button, Modal } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import dataAiSvg from '@/pages/intelligence/assets/svg/dataSource/appannie.svg';
import googlePlaySvg from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import appstoreSvg from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import facebookSvg from '@/pages/intelligence/assets/svg/dataSource/facebook.svg';
import youtubeSvg from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import twitchSvg from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';

import { useIntl } from 'umi';

import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

const AboutTheData = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const { formatMessage } = useIntl();

  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  const [isIconHover, setIsIconHover] = useState(false);

  return (
    <>
      <Button
        type="link"
        className="dbi-benchmark-mobile-infotips-inner"
        onClick={openModal}
        onMouseOver={() => {
          setIsIconHover(true);
        }}
        onMouseOut={() => {
          setIsIconHover(false);
        }}
      >
        <SvgIcon
          type={isIconHover ? 'alert-circle-action' : 'alert-circle-m'}
        />
        <span>{formatMessage({id: 'dbi_benchmark_about_the_data'})}</span>
      </Button>

      <Modal
        visible={isModalVisible}
        caption={formatMessage({id: 'dbi_benchmark_about_the_data'})}
        size={'l'}
        onClose={closeModal}
        className="dbi-benchmark-mobile-infotips-modal"
      >
        <Modal.Body>
          <div className="dbi-benchmark-modal-content">
            <div className="dbi-benchmark-modal-subtitle">
              {formatMessage({ id: 'dbi_benchmark_data_source'})}
            </div>
            <div className="dbi-benchmark-datasource">
              <div className="dbi-benchmark-mobile-line">
                <div className="dbi-benchmark-mobile-modal-iconbox">
                  <img src={dataAiSvg} className="dbi-benchmark-modal-icon" />
                  <span>Data.ai</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                 {formatMessage({ id: 'dbi_benchmark_mobile_data_ai_info'})}
                </div>
              </div>
              <div className="dbi-benchmark-mobile-line">
                <div className="dbi-benchmark-mobile-modal-iconbox">
                  <img src={googlePlaySvg} className="dbi-benchmark-modal-icon" />
                  <span style={{ marginRight: 10 }}>GooglePlay</span>
                  <img src={appstoreSvg} className="dbi-benchmark-modal-icon" />
                  <span>Appstore</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                  {formatMessage({ id: 'dbi_benchmark_google_app_info'})}
                </div>
              </div>
              <div className="dbi-benchmark-mobile-line">
                <div className="dbi-benchmark-mobile-modal-iconbox">
                  <img src={twitchSvg} className="dbi-benchmark-modal-icon" />
                  <span style={{ marginRight: 10 }}>Twitch</span>
                  <img src={youtubeSvg} className="dbi-benchmark-modal-icon" />
                  <span style={{ marginRight: 10 }}>Youtube</span>
                  <img src={facebookSvg} className="dbi-benchmark-modal-icon" />
                  <span>Facebook</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                  {formatMessage({ id: 'dbi_benchmark_mobile_tyf_info'})}
                </div>
              </div>
              {/* <div className="dbi-benchmark-mobile-line">
                <div className="dbi-benchmark-mobile-modal-iconbox">
                  <img src={steamnew} className="dbi-benchmark-modal-icon" />
                  <span>Steam</span>
                </div>
                <div className="dbi-benchmark-modal-text">
                  {formatMessage({ id: 'dbi_benchmark_steam_info'})}
                </div>
              </div> */}
            </div>

            <div className="dbi-benchmark-modal-text">
              {formatMessage({ id: 'dbi_benchmark_data_source_info'})}
            </div>
          </div>

          {/* <div className="dbi-benchmark-modal-content dbi-benchmark-methodology">
            <div className="dbi-benchmark-modal-subtitle">
              {formatMessage({ id: 'dbi_benchmark_methodology'})}
            </div>
            <div className="dbi-benchmark-modal-text">
              {formatMessage({ id: 'dbi_benchmark_calibration_info'})}
            </div>
            <div className="dbi-benchmark-modal-text">
             {formatMessage({ id: 'dbi_benchmark_estimation_info'})}
            </div>
          </div> */}
          <div className="dbi-benchmark-modal-content">
            <div className="dbi-benchmark-modal-subtitle">
             {formatMessage({ id: 'dbi_benchmark_contact_us'})}
            </div>
            <div className="dbi-benchmark-modal-text">
             {formatMessage({ id: 'dbi_benchmark_feedback'})}
            </div>
            <div className="dbi-benchmark-modal-text">
              velvetjiang@tencent.com
            </div>
            <div className="dbi-benchmark-modal-text">
              zhaofengliu@tencent.com
            </div>
            <div className="dbi-benchmark-modal-text">
              zakirzheng@tencent.com
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AboutTheData;
